const canvasSize = {width: 560, height: 960};

const slotBoard = {
    width: 840,
    height: 671,
    rowCount: 5,
    reelCount: 6,
}

const reels = {
    width: 131,
    height: 653,
    symbolsCount: 5
}

export const mobileConfigs = {
    canvasSize,
    slotBoard,
    reels,
}